import { render, staticRenderFns } from "./Annonces.vue?vue&type=template&id=229a7b24&"
import script from "./Annonces.vue?vue&type=script&lang=js&"
export * from "./Annonces.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports